import styled from "@emotion/styled";

const PageWrapper = styled.div`
    /* background-color: ${ (props) => props.theme.pageColor}; */
    display:flex;
    flex-direction: column;
    justify-content: center;
    @media (min-width: 600px){
            min-height: 100vh;
    }
    @media (max-width: 600px){
            padding-top: 50px;
            padding-bottom:30px;
    }
`

export { PageWrapper }